export const SharedLoginConstants = {
  AUTH_HEADER: 'Authorization',
  INTERRUPT_PATH: 'before',
  TRANSLATION_PKG: 'sso-login',
  XSRF_HEADER: 'XSRF-TOKEN',
  EMPLOYEE_REALM: 'employee',
  ANALYTICS_EVENTS: {
    LOGIN_RESULT: 'LoginResult',
  },
};
